import { FC } from 'react';
import { 
  PlayCircle,
  FileText,
  FileAudio,
  CheckSquare,
  Sparkles
} from 'lucide-react';
import { motion } from 'framer-motion';

const learningFormats = [
  {
    icon: PlayCircle,
    title: "VIDEO",
    description: "Lecciones en video que explican conceptos financieros de forma clara y entretenida, manteniendo a tu hijo enfocado mientras aprende.",
    color: "bg-blue-500",
    iconColor: "text-blue-500",
    bgGradient: "from-blue-500/5 to-blue-600/10",
    titleGradient: "from-blue-500 to-blue-600"
  },
  {
    icon: FileText,
    title: "TEXTO",
    description: "Material de lectura con ejemplos prácticos y ejercicios que refuerzan el aprendizaje de conceptos financieros importantes.",
    color: "bg-purple-500",
    iconColor: "text-purple-500",
    bgGradient: "from-purple-500/5 to-purple-600/10",
    titleGradient: "from-purple-500 to-purple-600"
  },
  {
    icon: FileAudio,
    title: "AUDIO",
    description: "Contenido narrado profesionalmente que permite a tu hijo aprender mientras escucha, ideal para diferentes estilos de aprendizaje.",
    color: "bg-pink-500",
    iconColor: "text-pink-500",
    bgGradient: "from-pink-500/5 to-pink-600/10",
    titleGradient: "from-pink-500 to-pink-600"
  },
  {
    icon: CheckSquare,
    title: "QUIZ",
    description: "Preguntas y ejercicios interactivos que ayudan a tu hijo a poner en práctica lo aprendido y reforzar sus conocimientos.",
    color: "bg-green-500",
    iconColor: "text-green-500",
    bgGradient: "from-green-500/5 to-green-600/10",
    titleGradient: "from-green-500 to-green-600"
  }
];

export const TeachingMethodology: FC = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary mb-6">
            <Sparkles className="h-4 w-4" />
            <span className="text-sm font-medium">Metodología de Enseñanza</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
            Aprendizaje Multiformato
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Combinamos diferentes formatos de contenido educativo para asegurar que tu hijo aprenda 
            de la manera más efectiva y entretenida posible
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {learningFormats.map((format, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative group"
            >
              <div className={`relative rounded-2xl bg-gradient-to-br ${format.bgGradient} p-8 hover:scale-[1.02] transition-transform duration-300`}>
                <div className="flex items-start gap-6">
                  {/* Icono */}
                  <div className={`h-14 w-14 rounded-xl ${format.color} bg-opacity-10 flex items-center justify-center shrink-0`}>
                    <format.icon className={`h-8 w-8 ${format.iconColor}`} />
                  </div>
                  
                  {/* Contenido */}
                  <div className="space-y-3">
                    <h3 className={`text-2xl font-bold bg-gradient-to-r ${format.titleGradient} bg-clip-text text-transparent tracking-wide`}>
                      {format.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {format.description}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
